import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthBypassBanner from './AuthBypassBanner';
import InstallPrompt from './InstallPrompt';

const navClass = ({ isActive }) => (isActive ? 'nav-link active' : 'nav-link');
const isOpaqueId = (value) => /^[a-f0-9]{32,}$/i.test((value || '').trim());
const obfuscateEmail = (email) => {
  const raw = (email || '').trim();
  if (!raw.includes('@')) return '';
  const [local, domain] = raw.split('@');
  if (!local || !domain) return '';
  const visible = local.length <= 2 ? local[0] : local.slice(0, 2);
  return `${visible}***@${domain}`;
};

const Layout = () => {
  const { user, loading, logout, authBypassActive } = useAuth();
  const rawName = user?.name || '';
  const rawEmail = user?.email || '';
  const safeName = !isOpaqueId(rawName) ? rawName : '';
  const userDisplayName = safeName || obfuscateEmail(rawEmail) || 'Authenticated User';

  return (
    <div className="layout-root">
      <InstallPrompt />
      <header className="app-nav-wrap">
        <nav className="app-nav">
          <div className="app-nav__brand">
            <span className="brand-mark" aria-hidden="true">D</span>
            <span className="brand-text">DocMerge</span>
          </div>

          <div className="app-nav__links">
            <NavLink to="/" end className={navClass}>
              Home
            </NavLink>
            <NavLink to="/dashboard" className={navClass}>
              Dashboard
            </NavLink>
            <NavLink to="/admin" className={navClass}>
              Admin
            </NavLink>
            <NavLink to="/published-policies" className={navClass}>
              Published
            </NavLink>
            <NavLink to="/pipeline" className={navClass}>
              Pipeline
            </NavLink>
          </div>

          <div className="app-nav__user">
            {loading ? (
              <div className="skeleton-row">
                <span className="skeleton skeleton-avatar" />
                <span className="skeleton skeleton-line skeleton-line--wide" />
              </div>
            ) : user ? (
              <>
                <span className="app-nav__name" title={user.email}>
                  {userDisplayName}
                </span>
                <button className="btn-ghost" onClick={logout}>Logout</button>
              </>
            ) : (
              <NavLink to="/login" className={navClass}>
                Login
              </NavLink>
            )}
          </div>
        </nav>
      </header>

      {authBypassActive && <AuthBypassBanner />}

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
